import React, { useEffect, useRef, useState } from 'react';
import '../../styles/transport.css'; // Import Hero specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

const benefitsData = [
  {
    number: '01',
    title: 'Seamless Integration',
    description: ' Efficient coordination between sea and land transport for smooth, continuous delivery from port to final destination.',
    icon: 'fa-sync-alt' // Font Awesome icon name for this benefit
  },
  {
    number: '02',
    title: 'Timely Deliveries',
    description: 'Reliable scheduling and streamlined operations ensure timely arrival of goods, reducing transit times and improving overall efficiency.',
    icon: 'fa-clock' // Font Awesome icon name for this benefit
  },
  {
    number: '03',
    title: 'Cost Efficiency',
    description: 'Optimized transport routes and combined modes of transport help lower shipping costs while maintaining high service standards.',
    icon: 'fa-coins' // Font Awesome icon name for this benefit
  },
  {
    number: '04',
    title: 'Real-Time Tracking',
    description: 'Comprehensive tracking capabilities provide visibility and updates throughout the entire journey, enhancing transparency and control.',
    icon: 'fa-location-crosshairs' // Font Awesome icon name for this benefit
  }
];

const BrokerageBenefits = () => {
  const [visibleItems, setVisibleItems] = useState([]);
  const benefitRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = entry.target.getAttribute('data-index');
          setVisibleItems((prev) => [...prev, index]);
          observer.unobserve(entry.target); // Stop observing the element
        }
      });
    });

    benefitRefs.current.forEach((benefit) => {
      if (benefit) {
        observer.observe(benefit);
      }
    });

    return () => {
      observer.disconnect(); // Cleanup the observer on component unmount
    };
  }, [benefitRefs]);
  return (
    <>
      <section id="benefits" className="py-5 benefits-services-section">
        <div className="overlay"></div>
        <div className='container-fluid px-0'> {/* Removed horizontal padding */}
                <div className="my-2 text-center">
                <button disabled className="custom-button mb-4 poppins-semibold">WHY CHOOSE US</button>
                <h1 className="poppins-bold text-light fs-1 mb-4">Key Benefits of Our Services</h1>
                </div>
            </div>
            <div className="container">
          <div className="container d-flex justify-content-center">
            <div className="col-lg-12 row g-0 d-flex justify-content-center">
              {benefitsData.map((benefit, index) => (
                <div
                  key={index}
                  className={`col-lg-6 col-md-6 col-sm-12 mb-4 d-flex justify-content-center benefit-card-container ${visibleItems.includes(index.toString()) ? 'animate' : ''}`}
                  ref={(el) => (benefitRefs.current[index] = el)}
                  data-index={index}
                >
                  <div className="benefits-container d-flex flex-row">
                    <div className="benefit-card-left">
                      <div className="icon-circle">
                        <i className={`fas ${benefit.icon}`}></i>
                      </div>
                      <div className="number">
                        <p className='outline-number'>{benefit.number}</p>
                      </div>
                    </div>
                    <div className="benefit-card-right text-dark">
                      <h3 className="benefit-title poppins-semibold">{benefit.title}</h3>
                      <p className="benefit-description poppins-medium">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BrokerageBenefits;
